import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import { useParams } from 'react-router-dom';
import FormRow from '../Form/FormRow';
import FormColumn from '../Form/FormColumn';
import Button from '../Button';

import { formatCurrency } from '../../utils/formatCurrency';
import './style.scss';
import { ricWorkflowName } from '../../utils/appConstants';

const LoanOfferConfirmation = ({ loanDetails, handleSubmitFrom, isDPOnly, isACH }) => {
  const renderSubTitle = () => (get(loanDetails, 'isAutoPayOffer') ? `If repaid within ${loanDetails.zipTerm} months* and enrolled in AutoPay` : 'Without AutoPay Enrollment');
  const match = useParams();
  const workflowType = get(match, 'workflowType') === 'luwa' ? 'dtm-luwa' : get(match, 'workflowType');

  return ( //
    <div className={`loan-offer-card ${isDPOnly ? 'dponly-loan-offer-card' : ''}`}>
      <div className="p-0 container-fluid">
        <div className="no-gutters row">
          {
            !!Number(get(loanDetails, 'zipTerm')) && (
              <div className="bg-white p-3 text-center col-12">
                <h2 className="mb-0 text-primary text-center" style={{ fontWeight: 500, fontSize: 32 }}>
                  {
                    Number(get(loanDetails, 'originationFee')) ? 'NO INTEREST' : '0% APR'
                  }
                </h2>
                <h5 className="mb-2">
                  {isDPOnly ? renderSubTitle() : `if paid within ${get(loanDetails, 'zipTerm')} months*`}
                </h5>
              </div>
            )
          }
          <div className="bg-white p-3 text-center col-12 top-section" style={{ zIndex: 1, position: 'relative', backgroundColor: '#f6f9fe' }}>
            <h5>Est. Monthly Payment</h5>
            <h1 className="mb-0 text-primary">
              $
              {formatCurrency(get(loanDetails, 'estimatedMonthlyPayment', 0), 2)}
            </h1>
          </div>
          <div className="bg-white col-12">
            <div className="p-3 container-fluid bottom-section" style={{ zIndex: 1, position: 'relative' }}>
              {isDPOnly ? (
                <FormRow className="mb-1 text-left">
                  <FormColumn offset={8}>
                    <h5>Amount of Sale</h5>
                  </FormColumn>
                  <FormColumn offset={4} className="align-right">
                    <strong className="text-primary">{`$${formatCurrency(get(loanDetails, 'approvalAmount', 0), 2)}`}</strong>
                  </FormColumn>
                </FormRow>
              ) : null}
              <FormRow className="mb-1 text-left">
                <FormColumn offset={8}>
                  <h5>Amount Financed</h5>
                </FormColumn>
                <FormColumn offset={4} className="align-right">
                  <strong className={isDPOnly ? 'text-primary' : ''}>
                    $
                    {formatCurrency(get(loanDetails, 'amountFinanced', 0), 2)}
                  </strong>
                </FormColumn>
              </FormRow>
              <FormRow className="mb-1 text-left">
                <FormColumn offset={8}>
                  <h5>{workflowType === ricWorkflowName ? 'Term' : 'Loan Term'}</h5>
                </FormColumn>
                <FormColumn offset={4} className="align-right">
                  <strong className={isDPOnly ? 'text-primary' : ''}>
                    {get(loanDetails, 'loanTerm', 0)}
                    {' '}
                    Months
                  </strong>
                </FormColumn>
              </FormRow>
              <FormRow className="mb-1 text-left">
                <FormColumn offset={8}>
                  <h5>Interest Rate</h5>
                </FormColumn>
                <FormColumn offset={4} className="align-right">
                  <strong className={isDPOnly ? 'text-primary' : ''}>
                    {formatCurrency(get(loanDetails, 'interestRate', 0), 2)}
                    %
                  </strong>
                </FormColumn>
              </FormRow>
              <FormRow className="mb-1 text-left">
                <FormColumn offset={8}>
                  <h5>Est. APR</h5>
                </FormColumn>
                <FormColumn offset={4} className="align-right">
                  <strong className={isDPOnly ? 'text-primary' : ''}>
                    {get(loanDetails, 'apr', 0)}
                    %
                  </strong>
                </FormColumn>
              </FormRow>
              {!isDPOnly && (
                <FormRow className="mb-1 text-left">
                  <FormColumn offset={8} className="origination-field">
                    <h5 className="mb-0">Origination Fee**</h5>
                    <small>Included in the monthly payment</small>
                  </FormColumn>
                  <FormColumn offset={4}>
                    <strong>
                      {`${formatCurrency(Number(get(loanDetails, 'originationFee', 0)) * 100, 2) || '-'}%`}
                    </strong>
                  </FormColumn>
                </FormRow>
              )}
              <FormRow className="mb-1">
                <FormColumn>
                  <Button
                    className="btn arrow btn-primary"
                    onClick={handleSubmitFrom}
                    title={isACH ? 'SUBMIT DOWN PAYMENT' : 'CONTINUE TO ESIGN'}
                  />
                </FormColumn>
              </FormRow>
              {get(loanDetails, 'downPaymentRequired') || isDPOnly ? (
                <FormRow className="down-payment-row text-left">
                  <FormColumn offset={8}>
                    <p>Down Payment**</p>
                  </FormColumn>
                  <FormColumn offset={4} className="align-right">
                    <b>{`$${formatCurrency(get(loanDetails, 'downPaymentRequired', 0), 2)}`}</b>
                  </FormColumn>
                </FormRow>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

LoanOfferConfirmation.propTypes = {
  loanDetails: PropTypes.object.isRequired,
  handleSubmitFrom: PropTypes.func.isRequired,
  isDPOnly: PropTypes.bool,
  isACH: PropTypes.bool,
};

LoanOfferConfirmation.defaultProps = {
  isDPOnly: false,
  isACH: false,
};

export default LoanOfferConfirmation;
